"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.HidePlaceholder = void 0;
var HidePlaceholder = function (target) {
    return /** @class */ (function (_super) {
        __extends(HidePlaceholder, _super);
        function HidePlaceholder() {
            var constructorArgs = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                constructorArgs[_i] = arguments[_i];
            }
            var _this = _super.apply(this, constructorArgs) || this;
            _this.placeholder = _this.normalizePlaceholder(_this.options.get('placeholder'));
            return _this;
        }
        HidePlaceholder.prototype.append = function (data) {
            data.results = this.removePlaceholder(data.results);
            _super.prototype.append.call(this, data);
        };
        HidePlaceholder.prototype.normalizePlaceholder = function (placeholder) {
            if (typeof placeholder === 'string') {
                placeholder = {
                    id: '',
                    text: placeholder
                };
            }
            return placeholder;
        };
        HidePlaceholder.prototype.removePlaceholder = function (data) {
            var modifiedData = data.slice(0);
            for (var d = data.length - 1; d >= 0; d--) {
                var item = data[d];
                if (this.placeholder.id === item.id) {
                    modifiedData.splice(d, 1);
                }
            }
            return modifiedData;
        };
        return HidePlaceholder;
    }(target));
};
exports.HidePlaceholder = HidePlaceholder;
//# sourceMappingURL=hide-placeholder.js.map